<template>
  <router-view></router-view>
</template>
<script>
import util from './utils/util';
export default {
  name: 'App',
  provide: {
    panoPromise: util.generatorPromise(),
  },
};
</script>
<style lang="scss">
@import './assets/scss/dealerMass3/core/setting';
@import './assets/scss/dealerMass3/module/_dlrLayerbase';
@import './assets/scss/modules/common/FormInput';
@import './assets/scss/modules/common/icon';
@import './assets/scss/modules/common/LayerBottom';

.overall-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.img-placeholder {
  display: inline-block;
  vertical-align: top;
  background: #f2f2f2 url(https://x.autoimg.cn/dealer/vr/assets/holdimg_white.png) no-repeat 50% 50%;
  background-size: 50% auto;
}
</style>
